import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import styles from '../pa_checklist.module.scss'
import { usePAChecklist } from '../pa_checklist_context';
import { isNullish } from '../../../../utils/misc_utils';

const FiltroChecklist = () => {
  const {
    interfaceAtiva,
    listaChecklistCaixa, filterObjCaixa, setFilterObjCaixa, setListaChecklistCaixaFiltrada,
    listaChecklistAnalise, filterObjAnalise, setFilterObjAnalise, setListaChecklistAnaliseFiltrada,
    listaChecklistProvaDeRoupa, filterObjProvaDeRoupa, setFilterObjProvaDeRoupa, setListaChecklistProvaDeRoupaFiltrada
  } = usePAChecklist();

  const filterFunction = (item, lista, filterObj) => {
    return lista.every(filter => {
      return isNullish(filterObj[filter.key]) || item[filter.key].toLowerCase().includes(filterObj[filter.key].toLowerCase())
    });
  }

  useEffect(() => {
    let listaFiltradaCaixa = Array.isArray(listaChecklistCaixa)
      ? listaChecklistCaixa.filter(item => filterFunction(item, listaFiltroCaixa, filterObjCaixa))
      : [];

    setListaChecklistCaixaFiltrada([...listaFiltradaCaixa]);
  }, [filterObjCaixa, listaChecklistCaixa]);

  useEffect(() => {
    let listaFiltradaAnalise = Array.isArray(listaChecklistAnalise)
      ? listaChecklistAnalise.filter(item => filterFunction(item, listaFiltroAnalise, filterObjAnalise))
      : [];

    if (filterObjAnalise.revisao_ok) {
      listaFiltradaAnalise = listaFiltradaAnalise.filter(item => item.revisao_ok);
    }

    setListaChecklistAnaliseFiltrada([...listaFiltradaAnalise]);
  }, [filterObjAnalise, listaChecklistAnalise]);

  useEffect(() => {
    let listaFiltradaProvaRoupa = Array.isArray(listaChecklistProvaDeRoupa)
     ? listaChecklistProvaDeRoupa.filter(item => filterFunction(item, listaFiltroProva, filterObjProvaDeRoupa))
     : [];

    if (filterObjProvaDeRoupa.revisao_ok) {
      listaFiltradaProvaRoupa = listaFiltradaProvaRoupa.filter(item => item.revisao_ok);
    }

    setListaChecklistProvaDeRoupaFiltrada([...listaFiltradaProvaRoupa]);
  }, [filterObjProvaDeRoupa, listaChecklistProvaDeRoupa]);

  const rgxTxt = value => value.replace(/[^a-z0-9.]/gi, '');

  const [listaFiltroCaixa] = useState([{
    key: 'romaneio_nf_saida', label: 'Romaneio Saída', rgx: rgxTxt, var: filterObjCaixa, setter: setFilterObjCaixa
  }]);
  const [listaFiltroAnalise] = useState([
    { key: 'nf_entrada', label: 'NF Entrada', rgx: rgxTxt, var: filterObjAnalise, setter: setFilterObjAnalise },
    { key: 'produto', label: 'Produto', rgx: rgxTxt, var: filterObjAnalise, setter: setFilterObjAnalise },
    { key: 'cor_produto', label: 'Cor Produto', rgx: rgxTxt, var: filterObjAnalise, setter: setFilterObjAnalise },
    { key: 'romaneio_nf_saida', label: 'Romaneio', rgx: rgxTxt, var: filterObjAnalise, setter: setFilterObjAnalise }
  ]);
  const [listaFiltroProva] = useState([
    { key: 'nf_entrada', label: 'NF Entrada', rgx: rgxTxt, var: filterObjProvaDeRoupa, setter: setFilterObjProvaDeRoupa },
    { key: 'produto', label: 'Produto', rgx: rgxTxt, var: filterObjProvaDeRoupa, setter: setFilterObjProvaDeRoupa },
    { key: 'cor_produto', label: 'Cor Produto', rgx: rgxTxt, var: filterObjProvaDeRoupa, setter: setFilterObjProvaDeRoupa },
    { key: 'romaneio_nf_saida', label: 'Romaneio', rgx: rgxTxt, var: filterObjProvaDeRoupa, setter: setFilterObjProvaDeRoupa }
  ]);

  return (
    <Form className={styles.filter_wrapper}>
      {
        (interfaceAtiva === 101 ? listaFiltroCaixa : interfaceAtiva === 102 ? listaFiltroAnalise : listaFiltroProva)
          .map((filter, index) => {
            return (
              <div key={index} style={{ display: 'flex', gap: '20px' }}>
                <Form.Group className={styles.filter_group}>
                  <Form.Label className={styles.filter_label}>{filter.label}</Form.Label>
                  <Form.Control
                    className={styles.filter_control}
                    type={'text'}
                    placeholder={filter.label}
                    value={
                      interfaceAtiva === 101 ? filterObjCaixa[filter.key]
                        : interfaceAtiva === 102 ? (filterObjAnalise[filter.key] || '')
                          : (filterObjProvaDeRoupa[filter.key] || '')
                    }
                    onChange={e => {
                      const base =
                        interfaceAtiva === 101
                          ? filterObjCaixa
                          : interfaceAtiva === 102
                            ? filterObjAnalise
                            : filterObjProvaDeRoupa;

                      filter.setter({
                        ...base,
                        [filter.key]: filter.rgx(e.target.value),
                      });
                    }}
                  />
                </Form.Group>
              </div>
            )
          })
      }
    </Form>
  );
}

export default FiltroChecklist;
